export default "__VITE_ASSET__CywsQZfr__"